import * as am4charts from "@amcharts/amcharts4/charts";
import { theme } from "../../styles/mui/theme";

/**
 * Applies the application's font family to all text elements in the chart
 */
export const applyAppFontFamily = (chart: am4charts.XYChart): void => {
  const fontFamily = String(theme.typography.fontFamily);
  chart.fontFamily = fontFamily;
  for (const serie of chart.series) {
    if (serie.tooltip) serie.tooltip.fontFamily = fontFamily;
    if (
      serie instanceof am4charts.ColumnSeries &&
      serie.columns.template.tooltip
    ) {
      serie.columns.template.tooltip.fontFamily = fontFamily;
    }
  }
};

export const configureNumberFormatter = (chart: am4charts.XYChart) => {
  chart.numberFormatter.numberFormat = "#.#a";
  chart.numberFormatter.bigNumberPrefixes = [
    { number: 1e3, suffix: "K" },
    { number: 1e6, suffix: "M" },
    { number: 1e9, suffix: "B" },
    { number: 1e12, suffix: "T" },
  ];
  chart.numberFormatter.smallNumberPrefixes = [];
};

export const configurePadding = (chart: am4charts.XYChart) => {
  chart.paddingTop = 20;
  chart.paddingLeft = 0;
  chart.paddingRight = 64;
  chart.paddingBottom = 0;
};
